import React, { Component, type ReactNode, Fragment } from 'react';
import type { Store } from 'redux';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import { ChannelsDialogSubscriber } from '@atlassian/jira-channels-jsd-services/src/controllers/channels-dialog/index.tsx';
import AppStyle from '@atlassian/jira-common-components-app-style/src/index.tsx';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import { ServiceDeskAnalyticsContext } from '@atlassian/jira-servicedesk-analytics/src/ui/servicedesk-analytics-context/index.tsx';
import type { AppPropsState } from './model/app-props/types.tsx';
import type { State } from './model/types.tsx';
import rootEpic from './ops/index.tsx';
import { setAppProps } from './state/actions/app-props/index.tsx';
import { fetchChannelsInfo } from './state/actions/app-state/index.tsx';
import createStore from './state/index.tsx';
import { ChatChannel } from './view/channels/chat/index.tsx';
import { CustomerAccessChannel } from './view/channels/customer-access/index.tsx';
import { EmailChannel } from './view/channels/email/index.tsx';
import { HelpCenterChannel } from './view/channels/help-center/index.tsx';
import { WidgetChannel } from './view/channels/widget/index.tsx';
import { ChannelsJsd } from './view/index.tsx';

const CHANNELS_JSD_APP_ID = 'servicedesk.channels-jsd';

const channelsAnalyticsAttributes = {
	level: 3,
	parentItemId: 'channels',
};

// eslint-disable-next-line jira/react/no-class-components
export class ChannelsJsdApp extends Component<AppPropsState> {
	constructor(props: AppPropsState) {
		super(props);
		this.store = createStore(rootEpic);
		this.store.dispatch(setAppProps(this.props));
		this.store.dispatch(fetchChannelsInfo());
	}

	store: Store<State>;

	render() {
		const AnalyticsWrapper = getWillShowNav4()
			? ({ children }: { children: ReactNode }) => (
					<ContextualAnalyticsData attributes={channelsAnalyticsAttributes}>
						{children}
					</ContextualAnalyticsData>
				)
			: Fragment;

		return (
			<ErrorBoundary id={CHANNELS_JSD_APP_ID}>
				<AppBase store={this.store}>
					<AppStyle>
						<ServiceDeskAnalyticsContext>
							<AnalyticsWrapper>
								<ChannelsDialogSubscriber>
									{(__, { setIsChannelsDialogOpen }) => (
										<ChannelsJsd
											EmailChannel={EmailChannel}
											WidgetChannel={WidgetChannel}
											HelpDeskChannel={HelpCenterChannel}
											ChatChannel={ChatChannel}
											CustomerAccessChannel={CustomerAccessChannel}
											onSetIsChannelsDialogOpen={setIsChannelsDialogOpen}
										/>
									)}
								</ChannelsDialogSubscriber>
							</AnalyticsWrapper>
						</ServiceDeskAnalyticsContext>
					</AppStyle>
				</AppBase>
			</ErrorBoundary>
		);
	}
}

export default ChannelsJsdApp;
